"use client"
import React, { useState } from "react"
import { downgradePlan } from "../../../../../services/billing"
import { useBilling } from "../../../../../context/BillingContext"
import { toast } from "react-toastify"

const DowngradeModal = ({ show, onClose ,data}) => {
  const { plans, refetchBilling } = useBilling()
  const [step, setStep] = useState(1)
  const [selectedPlanId, setSelectedPlanId] = useState(data?.selectedPlanId)
  const [downgradeLoader, setDowngradeLoader] = useState(false)
  const [reason, setReason] = useState("")
  const [feedback, setFeedback] = useState("")
  const [error, setError] = useState("")

  const currentPlanIndex = plans?.findIndex((plan) => plan.current)
  const availablePlans = currentPlanIndex > 0 ? plans.slice(0, currentPlanIndex) : []

  if (!show) return null

  const handleNext = () => {
    if (step === 1 && !reason) return setError("Please select a reason")
    if (step === 2 && !feedback.trim()) return setError("Please enter feedback")
    setError("")
    setStep(step + 1)
  }

  const handleBack = () => {
    setError("")
    setStep(step - 1)
  }

  const handleSubmit = async () => {
    if (!selectedPlanId) {
      setError("Please select a downgrade plan")
      return
    }
    try {
      setDowngradeLoader(true)
      const params = {
        package_id: selectedPlanId,
        reason,
        feedback
      }
      const response = await downgradePlan(params)
      await refetchBilling()
      toast.success(response?.data?.message || "Downgrade successful", {
        position: "bottom-right",
      })
      closeModal()
    } catch (err) {
      console.error('Errror on downgrade API calling : ', err)
    } finally {
      setDowngradeLoader(false)
    }
  }

  const closeModal = () => {
    setSelectedPlanId(null)
    setStep(1)
    setReason("")
    setFeedback("")
    setError("")
    onClose()
  }

  return (
    <div
      className="modal d-flex align-items-center justify-content-center"
      style={{
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1052,
      }}
      onClick={closeModal}
    >
      <div
        key={step}
        className="modal-dialog modal-lg animate-flip"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title fw-semibold">Downgrade Your Plan</h5>
            <div className="modal-close-btn">
              <button type="button" className="btn-close" onClick={closeModal}></button>
            </div>
          </div>
          <div className="modal-body package-modal p-4">
            {/* Error Message */}
            {error && <div className="alert alert-danger py-2">{error}</div>}

            {/* Step 1 - Reason */}
            {step === 1 && (
              <>
                <h6 className="mb-3">Reason for Downgrading</h6>
                <select
                  className="form-select mb-3"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                >
                  <option value="">Select a reason...</option>
                  <option>Too expensive</option>
                  <option>Not using all features</option>
                  <option>Switching to competitor</option>
                  <option>Other</option>
                </select>
                <div className="d-flex">
                  <button
                    className="btn btn-outline-secondary me-2 flex-fill"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn plan-detail-card-btn flex-fill"
                    onClick={handleNext}
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {/* Step 2 - Feedback */}
            {step === 2 && (
              <>
                <h6 className="mb-3">Additional Feedback</h6>
                <textarea
                  className="form-control mb-3"
                  rows="3"
                  placeholder="Your feedback..."
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                />
                <div className="d-flex">
                  <button
                    className="btn btn-secondary me-2 flex-fill"
                    onClick={handleBack}
                  >
                    Back
                  </button>
                  <button
                    className="btn plan-detail-card-btn flex-fill"
                    onClick={handleNext}
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {/* Step 3 - Confirmation */}
            {step === 3 && (
              <>
                <div className="alert alert-warning">
                  ⚠️ Downgrading may result in data loss and restricted access for
                  some team members.
                </div>
                <div className="d-flex">
                  <button
                    className="btn btn-secondary me-2 flex-fill"
                    onClick={handleBack}
                  >
                    Back
                  </button>
                  <button
                    className="btn plan-detail-card-btn flex-fill"
                    onClick={handleSubmit}
                  >
                    Continue
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DowngradeModal
